import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const connectProjectsEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-connect-projects-entrypoint" */ './src'),
	),
	getPreloadProps: ({ context }: EntryPointRouteParams) => ({
		extraProps: {
			query: context.query,
		},
	}),
});
